<template>
  <div style="padding: 0; margin: 0; height: 100%;">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Blank'
}
</script>
